import React, {FC} from 'react'
import './ProductList.scss'
import {NavLink} from "react-router-dom";
import ProductItem from '../ProductItem/ProductItem'
import {IProduct} from "../../types/types";

interface IProductList {
    list:Array<IProduct>
}
const ProductList:FC<IProductList> = ({list}) => {

    return (
        <div className='productList'>
            {list.map(item => (
                <ProductItem
                    key={item.id}
                    product={item}
                    className='list__item'
                />
            ))}
        </div>
    )
}

export default ProductList